import { AlphaRCircleOutlineIcon } from './AlphaRCircleOutlineIcon';

/**
 * author: Contributors
 * id 3EFEFA7D-EE69-4813-93AB-096C148CC74B
 * name alpha-r-circle-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-r-circle-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterRCircleOutlineIcon = AlphaRCircleOutlineIcon;
export default LetterRCircleOutlineIcon